export function toOptions(array: string[]): { title: string; value: string }[] {
  return array.map((d) => {
    return { title: d, value: d };
  });
}
